import React, {Component} from 'react';
import {matchRoutes} from 'react-router-config';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import * as Actions from 'auth/store/actions';
import { reAuth } from '../../../config';

let redirect = false;

class FuseAuthorization extends Component {
// eslint-disable-next-line
    constructor(props)
    {
        super(props);

        /*var auth = Utils.readCookie('auth');
        if(auth != null && auth.length > 5){
          auth = JSON.parse(auth);
          this.props.refreshLogin(auth);
        }*/
    }

    componentDidUpdate(prevProps)
    {
        /**
         * If route is changed
         * Update auths
         */
        if ( !_.isEqual(this.props.location.pathname, prevProps.location.pathname) )
        {
            this.checkAuth();
        }
    }

    componentWillMount(){
        this.checkAuth();
    }
    
    isEmpty(str){
        return (!str || 0 === str.length);
    }

    checkAuth()
    {
        const matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
    
            if ( matched && matched.route.auth && matched.route.auth.length > 0 )
            {
                var intersect = _.intersection(this.props.user.role, matched.route.auth);
                
                if(this.props.user.role === 'unauthenticated' && this.isEmpty(window.localStorage.getItem('feathers-jwt'))){
                     reAuth().then(u=>{
                        console.log('Re-Auth');
                    }).catch(e=>{
                        this.handleRedirect(intersect);    
                    })
                } else {
                    this.handleRedirect(intersect);
                } 
                
            }


    }

    handleRedirect(intersect){
        if(intersect.length === 0){
            redirect = true;
            if ( this.props.user.role === 'unauthenticated' )
            {
                this.props.history.push({
                    pathname: '/login',
                    state   : {redirectUrl: this.props.location.pathname}
                });
            }
            else
            {
                this.props.history.push({
                    pathname: '/'
                });
            }
        }
    }

    shouldComponentUpdate(nextProps)
    {
        if ( redirect )
        {
            redirect = false;
            return false;
        }
        else
        {
            return true;
        }
    }

    render()
    {
        const {children} = this.props;

        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch)
{
  return bindActionCreators({
    setUserData: Actions.setUserData,
    setUserDataFromDB: Actions.setUserDataFromDB,
  }, dispatch);
}

function mapStateToProps({fuse, auth})
{
    return {
        user: auth.user
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FuseAuthorization));



// WEBPACK FOOTER //
// ./src/@fuse/components/FuseAuthorization/FuseAuthorization.js